module.exports = __webpack_public_path__ + "static/img/surface14.47a6690.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface14.png
// module id = x4n6
// module chunks = 2